import * as React from 'react'
import PropTypes from 'prop-types'
import { useUser } from 'api'
import Auth from 'containers/Auth/Auth'
import Container from 'components/Container'
import Section from 'components/Section'
import Typography from 'components/Typography'
import { useTranslations } from 'containers/Translations/TranslationsContext'

function AuthWrapper(props) {
  const { children, ambassador } = props

  const { initiated, isAuthenticated, isAmbassadorUser } = useUser()
  const t = useTranslations()

  if (!initiated) {
    return <div style={{ height: '100vh' }} />
  }

  if (isAuthenticated && ambassador && !isAmbassadorUser) {
    return (
      <Section gutters="padding">
        <Container maxWidth="xs">
          <Typography variant="h5" align="center">
            {t('Web.AuthWrapper.Unauthorized')}
          </Typography>
        </Container>
      </Section>
    )
  }

  if (isAuthenticated) {
    return children
  }

  return (
    <Section gutters="padding">
      <Container maxWidth="xs">
        <Auth />
      </Container>
    </Section>
  )
}

AuthWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  ambassador: PropTypes.bool,
}

export default AuthWrapper
